import { useSelector } from 'react-redux';
import { RootState } from 'store';

const WelcomeHero = () => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="text-text-primary space-y-6">
      <img
        src={
          isDarkMode
            ? '/chatwithdocstarted-dark.png'
            : '/chatwithdocstarted.png'
        }
        className="max-h-[120px] md:max-h-[146px] h-full"
        alt="Chat with Docs"
      />

      <h1 className="text-2xl md:text-5xl font-medium text-text-primary lg:leading-[60px]">
        Welcome to Chat with Doc
      </h1>
      <p className="text-sm lg:text-xl font-normal text-text-primary md:w-[400px] mb-6 lg:mb-0">
        Your personal assistant for navigating and understanding your documents
        with ease. Simply upload your file and start a conversation!
      </p>
    </div>
  );
};

export default WelcomeHero;
